import { useMediaQuery } from "@mui/material";

export function useIsSmallVerticalSpacing() {
  return useMediaQuery("(max-height: 700px)");
}
